<template>
	<div class="templates">
		<md-field class="md-field-margin">
			<label>Email Template:</label>
			<md-input v-model="template.name" name="name" v-validate="'required|max:60'" @input="template.name = sanitizeInput($event)"></md-input>
		</md-field>
			<p v-show="errors.has('name')" v-text="errors.first('name')" class="error"></p>
		<md-field class="md-field-margin">
			<label>Description:</label>
			<md-input v-model="template.description" name="description" v-validate="'required|max:100'" @input="template.description = sanitizeInput($event)"></md-input>
		</md-field>
			<p class="error" v-show="errors.has('description')" v-text="errors.first('description')"></p>
		<md-field class="md-field-margin">
			<label>Subject:</label>
			<md-input v-model="template.subject" name="subject" v-validate="'required|max:100'" @input="template.subject = sanitizeInput($event)"></md-input>
		</md-field>
			<p class="error" v-show="errors.has('subject')" v-text="errors.first('subject')"></p>
		<md-field class="md-field-margin">
			<label>Reference Id:</label>
			<md-input v-model="template.ref_id" disabled></md-input>
		</md-field>
		<md-field class="tempTxtArea md-field-margin">
			<label>Body HTML:</label>
			<md-textarea v-model="template.html" name="body html" v-validate="'required'" @blur="template.html = $event.target.value"></md-textarea>
		</md-field>
			<p class="error" v-show="errors.has('body html')" v-text="errors.first('body html')"></p>
		<md-field class="tempTxtArea md-field-margin">
			<label>Body Text:</label>
			<md-textarea v-model="template.text" name="body text" v-validate="'required|max:5000'" @blur="template.text = sanitizeInput($event.target.value)"></md-textarea>
		</md-field>
			<p class="error" v-show="errors.has('body text')" v-text="errors.first('body text')"></p>
		<md-field class="md-field-margin">
			<label>Email Category:</label>
			<md-select v-model="template.category" name="Email category"  v-validate="'required'" placeholder="Email category" id="category">
				<md-option value="None">None (no category)</md-option>
				<md-option value="Approvals">Approvals</md-option>
				<md-option value="Escalate">Escalate</md-option>
				<md-option value="Requests">Requests</md-option>
				<md-option value="Responses">Responses</md-option>
				<md-option value="Feedback">Feedback</md-option>
				<md-option value="Referee">Referee</md-option>
				<md-option value="Unsubscribe">Unsubscribe</md-option>
				<md-option value="Members">Members</md-option>
				<md-option value="Reports">Reports</md-option>
				<md-option value="recruiting">Recruiting</md-option>
				<md-option value="profileUpdate">Profile Update</md-option>
				<md-option value="noFollowUp">No Follow Up</md-option>
			</md-select>
		</md-field>
			<p class="error" v-show="errors.has('Email category')" v-text="errors.first('Email category')"></p>
		<md-field class="md-field-margin">
			<md-button class="md-raised md-round md-accent" @click="save">{{ saveText }}</md-button>
			<md-button class="md-raised md-round md-accent m-left-20" @click="deleteTemplate()">Delete</md-button>
		</md-field>
	</div>
</template>
<!-- Script-->
<script>
import API from "../services/API";
import { sanitizeInput, sanitizeHtmlTemplate } from '../utils/sanitizer';
export default {
  	props: ["template_id"],
  	data() {
	    return {
	      	api: new API(),
	      	saveText: "save",
	      	template: {},
	      	fullPage: true
	    };
  	},
  	watch: {
    	$route: "loadData"
  	},
  	created() {
		this.loadData();
	},
  	methods: {
		sanitizeInput(input) {
		    return sanitizeInput(input);
		},
		/*sanitizeHtmlTemplate(input) {
		    return sanitizeHtmlTemplate(input);
		},*/
	    loadData: async function() {
	      	this.saveText = "save";
	      	await this.api.get(`templates/${this.template_id}`).then(template => {
	        	this.template = template.data;
	      	});
	    },
	    save: async function() {
	    	this.$validator.validateAll().then(async (result) => {
	    		if (result) {
			      	await this.api
			        .put(`templates/${this.template_id}`, this.template)
			        .then(template => {
			          this.$emit("reload");
			          this.saveText = "saved";
			          this.template = template.data;
			        });
		        }
		    }).catch(err => {
		    	return new Promise((resolve, reject) => {
		    		resolve(err);
		    	});
		    });
	    },
	    async deleteTemplate() {
	    	await this.api.put(`templates/${this.template_id}/delete`, { deleted: true }).then(template => {
				this.$emit("reload");
	          	this.$router.push('/');
	        });
	    }
  	}
};
</script>



// WEBPACK FOOTER //
// src/components/Template.vue